import LegalDocPage from '@/components/LegalDocPage';

// Readable copy of the agreement practitioners tick during onboarding — they were asked to
// acknowledge it with no way to open it (owner, Jun 2026).
const PractitionerAgreementDoc = () => (
  <LegalDocPage documentType="practitioner_agreement" title="Practitioner / Expert / Contributor Agreement" />
);

export default PractitionerAgreementDoc;
